<template>
    <el-select
        v-if="mode === 'edit'"
        :placeholder="placeholder"
        :modelValue="modelValue"
        :filterable="filterable"
        :disabled="disabled"
        :data-bot="dataBot"
        :popperAppendToBody="appendToBody"
        popperClass="custom-dropdown"
        :emptyValues="[null]"
        @change="update"
    >
        <el-option v-if="selectNothing" :label="selectNothing" :value="null" />
        <el-option
            v-for="option in options"
            :key="option[idColumn]"
            :label="option[labelColumn]"
            :value="option[idColumn]"
            :disabled="!!option.disabled"
        >
            <slot :option="option">{{ option[labelColumn] }}</slot>
        </el-option>
    </el-select>
    <p v-else>
        {{ labelFromValue }}
    </p>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: '',
        },
        modelValue: {
            type: [Number, String],
            required: false,
            default: '',
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        labelColumn: {
            type: String,
            required: false,
            default: 'label',
        },
        idColumn: {
            type: String,
            required: false,
            default: 'value',
        },
        filterable: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        selectNothing: {
            type: [String, Boolean],
            required: false,
            default: false,
        },
        appendToBody: {
            type: Boolean,
            default: false,
        },
        dataBot: {
            type: String,
            required: false,
            default: '',
        },
    },
    emits: ['update:modelValue'],
    computed: {
        labelFromValue() {
            return this.options.find((option) => option[this.idColumn] === this.modelValue)[
                this.labelColumn
            ];
        },
    },
    methods: {
        update(newValue) {
            this.$emit('update:modelValue', newValue);
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.el-select-dropdown.el-popper.custom-dropdown {
    box-shadow: 0 0 12px rgba(17, 17, 17, 0.24);
    border-radius: 6px;
    margin-top: 4px;
    .popper__arrow {
        display: none;
    }
    .el-select-dropdown__list {
        padding: 8px 0;
        .el-select-dropdown__item {
            border-radius: 4px;
            margin: 0 8px;
            padding: 0 8px;
        }
    }
}
</style>
